import { useMutation } from "react-query";

import { AxiosError } from "axios";

import { makeRequest } from "../../util";
import { RunCrawlerRequest } from "../types";

async function adminSetUpWebTrackerDomain(
  data: RunCrawlerRequest
): Promise<{}> {
  await makeRequest<{}>("admin_set_up_web_tracker_domain", data);

  return {};
}

export default function useAdminSetUpWebTrackerDomain(
  onSuccess: () => void,
  onError: (errorMessage: string) => void
) {
  return useMutation<
    {},
    AxiosError<{ error_message: string }>,
    RunCrawlerRequest
  >(adminSetUpWebTrackerDomain, {
    onSuccess: () => {
      onSuccess();
    },
    onError: (error) => {
      onError(
        error.response?.data.error_message ?? "Unknown error setting up domain"
      );
    },
  });
}
